import { render, staticRenderFns } from "./rk-footer-time.vue?vue&type=template&id=04db0ca3&scoped=true&"
import script from "./rk-footer-time.vue?vue&type=script&lang=ts&"
export * from "./rk-footer-time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db0ca3",
  null
  
)

export default component.exports